import { defineMessages } from "react-intl"

export const inventoryActiveFiltersMessages = defineMessages({
	closeFilters: {
		defaultMessage: "Close filters",
		id: "inventorylist.filters.close",
	},
	resetFilters: {
		defaultMessage: "Reset all filters",
		id: "inventorylist.filter.resetFilters",
	},
	showFilters: {
		defaultMessage: "Show filters",
		id: "inventorylist.filters.show",
	},
	smartSearchButton: {
		defaultMessage: "Smart search",
		id: "inventorylist.filters.smartSearchButton",
	},
	smartSearchPlaceholder: {
		defaultMessage: "New black 911 Carrera S with sport chrono",
		id: "inventorylist.filters.smartSearchPlaceholder",
	},
	smartSearchPlaceholder2: {
		defaultMessage: "Red Taycan Turbo with performance battery",
		id: "inventorylist.filters.smartSearchPlaceholder2",
	},
	smartSearchPlaceholder3: {
		defaultMessage: "Used Cayenne under 50,000 {distance}",
		id: "inventorylist.filters.smartSearchPlaceholder3",
	},
	smartSearchPlaceholder4: {
		defaultMessage: "White Macan with panoramic roof",
		id: "inventorylist.filters.smartSearchPlaceholder4",
	},
	smartSearchTooltip: {
		defaultMessage: "Enter a few keywords for your search. The smart search will apply the filters.",
		id: "inventorylist.filters.smartSearchTooltip",
	},
})
